import React from "react";

import css from "./form-element.module.css";

export default function FormElement({ label, width, children, style }) {
	const getLabel = label && <label>{label}</label>;

	const sty = width
		? {
				flex: `0 1 ${width}%`,
		  }
		: {};

	return (
		<div className={css.formEl} style={{ ...sty, ...style }}>
			{getLabel}
			{children}
		</div>
	);
}
